/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function addressValidationQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('AddressValidation', 'FormattedAddresses', DataServiceEntities.FormattedAddressesExtensionClass, key);
}

export function createGetAddressesInput(
    queryResultSettings: IQueryResultSettings,
    partialAddressSearchString: string
): IDataServiceRequest {
    const query = addressValidationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAddresses',
        true,
        DataServiceEntities.FormattedAddressJsonExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IFormattedAddressJson' },
        { partialAddressSearchString: partialAddressSearchString }
    );
}

export function getAddressesAsync(
    context: IContext,
    partialAddressSearchString: string
): AsyncResult<DataServiceEntities.IFormattedAddressJson[]> {
    const request = createGetAddressesInput(context.queryResultSettings || {}, partialAddressSearchString);
    return callActionOrExecute<DataServiceEntities.IFormattedAddressJson[]>(request, context.callerContext);
}

export function createGetValidAddressInput(
    queryResultSettings: IQueryResultSettings,
    cpid: string,
    range: number,
    unformattedAddress: string,
    unformattedPartialAddress: string
): IDataServiceRequest {
    const query = addressValidationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetValidAddress',
        true,
        DataServiceEntities.MunicipalAddressExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IMunicipalAddress' },
        { cpid: cpid, range: range, unformattedAddress: unformattedAddress, unformattedPartialAddress: unformattedPartialAddress }
    );
}

export function getValidAddressAsync(
    context: IContext,
    cpid: string,
    range: number,
    unformattedAddress: string,
    unformattedPartialAddress: string
): AsyncResult<DataServiceEntities.IMunicipalAddress[]> {
    const request = createGetValidAddressInput(
        context.queryResultSettings || {},
        cpid,
        range,
        unformattedAddress,
        unformattedPartialAddress
    );
    return callActionOrExecute<DataServiceEntities.IMunicipalAddress[]>(request, context.callerContext);
}

// @ts-ignore
function aTSQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('ATS', 'ATSSectionNumber', DataServiceEntities.ATSSectionNumberExtensionClass, key);
}

export function createGetATSSectionNumberDetailInput(aTSSectionNumber: string): IDataServiceRequest {
    const query = aTSQuery();
    return query.createDataServiceRequestForOperation(
        'GetATSSectionNumberDetail',
        true,
        DataServiceEntities.GetATSSectionNumberDataResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetATSSectionNumberDataResponse' },
        { ATSSectionNumber: aTSSectionNumber }
    );
}

export function getATSSectionNumberDetailAsync(
    context: IContext,
    aTSSectionNumber: string
): AsyncResult<DataServiceEntities.IGetATSSectionNumberDataResponse> {
    const request = createGetATSSectionNumberDetailInput(aTSSectionNumber);
    return callActionOrExecute<DataServiceEntities.IGetATSSectionNumberDataResponse>(request, context.callerContext);
}

// @ts-ignore
function communitiesQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('Communities', 'CommunityEntity', DataServiceEntities.CommunityEntityExtensionClass, key);
}

export function createGetCommunityInput(queryResultSettings: IQueryResultSettings, communityCode: string): IDataServiceRequest {
    const query = communitiesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCommunity',
        true,
        DataServiceEntities.CommunityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICommunity' },
        { communityCode: communityCode }
    );
}

export function getCommunityAsync(context: IContext, communityCode: string): AsyncResult<DataServiceEntities.ICommunity[]> {
    const request = createGetCommunityInput(context.queryResultSettings || {}, communityCode);
    return callActionOrExecute<DataServiceEntities.ICommunity[]>(request, context.callerContext);
}

// @ts-ignore
function documentAvailabilityQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('DocumentAvailability', 'DocumentDetail', DataServiceEntities.DocumentDetailExtensionClass, key);
}

export function createGetDocumentAvailabilityInput(
    documentSearchCriteria: DataServiceEntities.IDocumentSearchCriteria
): IDataServiceRequest {
    const query = documentAvailabilityQuery();
    return query.createDataServiceRequestForOperation(
        'GetDocumentAvailability',
        true,
        DataServiceEntities.DocumentDetailExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IDocumentDetail' },
        { documentSearchCriteria: documentSearchCriteria }
    );
}

export function getDocumentAvailabilityAsync(
    context: IContext,
    documentSearchCriteria: DataServiceEntities.IDocumentSearchCriteria
): AsyncResult<DataServiceEntities.IDocumentDetail> {
    const request = createGetDocumentAvailabilityInput(documentSearchCriteria);
    return callActionOrExecute<DataServiceEntities.IDocumentDetail>(request, context.callerContext);
}

// @ts-ignore
function downloadDocumentQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('DownloadDocument', 'Order', DataServiceEntities.OrderExtensionClass, key);
}

export function createDownloadInput(
    orderId: string,
    order: DataServiceEntities.IOrder,
    userEmail: string,
    companyName: string
): IDataServiceRequest {
    const query = downloadDocumentQuery();
    return query.createDataServiceRequestForOperation(
        'Download',
        true,
        DataServiceEntities.OrderExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IOrder' },
        { orderId: orderId, order: order, userEmail: userEmail, companyName: companyName }
    );
}

export function downloadAsync(
    context: IContext,
    orderId: string,
    order: DataServiceEntities.IOrder,
    userEmail: string,
    companyName: string
): AsyncResult<DataServiceEntities.IOrder> {
    const request = createDownloadInput(orderId, order, userEmail, companyName);
    return callActionOrExecute<DataServiceEntities.IOrder>(request, context.callerContext);
}

// @ts-ignore
function electronicBlockProfileQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ElectronicBlockProfile',
        'ElectronicBlockProfile',
        DataServiceEntities.ElectronicBlockProfileExtensionClass,
        key
    );
}

export function createGetElectronicBlockProfileDocIdsInput(dOC_ID: string): IDataServiceRequest {
    const query = electronicBlockProfileQuery();
    return query.createDataServiceRequestForOperation(
        'GetElectronicBlockProfileDocIds',
        true,
        DataServiceEntities.ElectronicBlockProfileExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IElectronicBlockProfile' },
        { DOC_ID: dOC_ID }
    );
}

export function getElectronicBlockProfileDocIdsAsync(
    context: IContext,
    dOC_ID: string
): AsyncResult<DataServiceEntities.IElectronicBlockProfile> {
    const request = createGetElectronicBlockProfileDocIdsInput(dOC_ID);
    return callActionOrExecute<DataServiceEntities.IElectronicBlockProfile>(request, context.callerContext);
}
// @ts-ignore
function sasTokenQuery(secureBlobUrl?: string): DataServiceQuery {
    const key = secureBlobUrl ? { SecureBlobUrl: secureBlobUrl } : null;
    return new DataServiceQuery('SasToken', 'SecureBlobDetail', DataServiceEntities.SecureBlobDetailExtensionClass, key);
}

export function createGetDocumentBlobSecureUrlInput(orderId: string, documentName: string, uniqueId: string): IDataServiceRequest {
    const query = sasTokenQuery();
    return query.createDataServiceRequestForOperation(
        'GetDocumentBlobSecureUrl',
        true,
        DataServiceEntities.SecureBlobDetailExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ISecureBlobDetail' },
        { orderId: orderId, documentName: documentName, uniqueId: uniqueId }
    );
}

export function getDocumentBlobSecureUrlAsync(
    context: IContext,
    orderId: string,
    documentName: string,
    uniqueId: string
): AsyncResult<DataServiceEntities.ISecureBlobDetail> {
    const request = createGetDocumentBlobSecureUrlInput(orderId, documentName, uniqueId);
    return callActionOrExecute<DataServiceEntities.ISecureBlobDetail>(request, context.callerContext);
}
